import _ from 'lodash'

import {
  LegacyPage,
  Model,
  LoadingContainer,
  Panels,
  Bar,
} from 'peach/components'
import { humanizeKey } from 'peach/helpers'
import { useParams } from 'peach/router'

import {
  useInternalListTemplateDescriptors,
  useInternalListTemplateVersionsModern,
} from 'core/types'

const TemplateSubjectChannel = () => {
  const { companyId, subjectKey, channelKey } = useParams<{
    companyId?: string
    subjectKey?: string
    channelKey?: string
  }>()

  const {
    data: descriptorsList,
    isLoading: descriptorsLoading,
    error: descriptorsError,
  } = useInternalListTemplateDescriptors({
    companyId,
  })

  const {
    data: templatesList,
    isLoading: templatesLoading,
    error: templatesError,
  } = useInternalListTemplateVersionsModern({
    companyId,
  })

  const isLoading = descriptorsLoading || templatesLoading
  const error = descriptorsError || templatesError

  const descriptor = _.find(descriptorsList, {
    subject: subjectKey,
    channel: channelKey,
  })

  const templates = _.filter(templatesList, { descriptorId: descriptor?.id })

  return (
    <LoadingContainer error={error} isLoading={isLoading}>
      <Panels
        header={
          <Bar
            title={`${humanizeKey(subjectKey)} - ${humanizeKey(channelKey)}`}
          />
        }
      >
        <LegacyPage.Full>
          <Model.Item json={descriptor} title='Descriptor' />
          <Model.List json={templates} noLink title='Templates' />
        </LegacyPage.Full>
      </Panels>
    </LoadingContainer>
  )
}

export default TemplateSubjectChannel
